import { useEffect, useState } from "react";
import { fetchEmpresaLogoBlob } from "@services/empresaLogoService";

const IDLE = { status: "idle", url: null };
const LOADING = { status: "loading", url: null };

const chaveLogo = (empresaId, versao) => `${empresaId}:${versao ?? ""}`;

// Busca o logo autenticado da empresa e expõe uma object URL. Trocar `versao`
// (logo_at) refaz a busca; a URL anterior é revogada no cleanup, e nunca é
// exibida uma URL de outra empresa/versão (a chave é conferida no retorno).
export const useEmpresaLogoUrl = ({ empresaId, versao, ativo }) => {
  const [estado, setEstado] = useState({ chave: null, ...LOADING });

  useEffect(() => {
    if (!ativo || empresaId == null) return undefined;

    let cancelado = false;
    let url = null;
    const chave = chaveLogo(empresaId, versao);
    setEstado({ chave, ...LOADING });

    fetchEmpresaLogoBlob(empresaId)
      .then((blob) => {
        if (cancelado) return;
        url = URL.createObjectURL(blob);
        setEstado({ chave, status: "ready", url });
      })
      .catch(() => {
        if (!cancelado) setEstado({ chave, status: "error", url: null });
      });

    return () => {
      cancelado = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [ativo, empresaId, versao]);

  if (!ativo || empresaId == null) return IDLE;
  return estado.chave === chaveLogo(empresaId, versao)
    ? estado
    : { chave: null, ...LOADING };
};
